import ConfigNode from 'Model/ConfigNode'
import { branch } from 'Model/constants'

class RelationSizeParams extends ConfigNode
  @className = 'RelationSizeParams'

  constructor: ->
    super('relationSizeParams')

  @load: ->
    super('relationSizeParams', @)

  update: (key) ->
    @set('value', key)
    @save()

  key: ->
    @get('value')

  reset: ->
    @update(undefined)

export default RelationSizeParams
